import { GET_GOOGLE_CUSTOM_TOKEN } from "@/data/urls";
import api from "@/utils/api";

/**
 * Exchanges a Firebase ID token for a custom auth token (e.g. for galleries or app deep link).
 * @param idToken - Firebase ID token from auth.currentUser.getIdToken()
 * @returns The custom token string, or null if the request failed or response has no token
 */
export const getCustomAuthToken = async (
  idToken: string,
): Promise<string | null> => {
  if (!idToken) return null;
  try {
    const res = await api.get<{ token: string }>(
      `${GET_GOOGLE_CUSTOM_TOKEN}?token=${encodeURIComponent(idToken)}`,
    );
    return res.data?.token ?? null;
  } catch (error) {
    console.error(`[Firebase custom token API] Request failed.`, error);
    return null;
  }
};
